import base from '../dr-base'
import drDataWidget from './dr-data-widget.vue'

const schema =  {
  $Type: 'dr-data-widget',
  name: 'Data widget',
  ...base,
  group: 'Data widgets',
  icon: 'database',
  properties: {
    ...base.properties,
    Widgets: {
      type: 'array'
    },
    DataSource: {
      type: 'object',
      component: 'dr-data-widget-prop-editor',
      properties: {
        Type: {
          name: 'drDataWidgetPropEditor.resourceProvider',
          type: 'string',
          default: 'context',
          enum: [{
            value: 'context',
            text: 'Context'
          }, {
            value: 'datasource',
            text: 'DataSource'
          }, {
            value: 'microflow',
            text: 'Microflow'
          }, {
            value: 'objectmodel',
            text: 'ObjectModel'
          }]
        },
        Value: {
          name: 'vuetifyWidgets.dr-data-widget.value',
          type: 'string',
          default: 'Value'
        },
        MicroFlow: {
          name: 'Microflow Id',
          type: 'string'
        },
        Parameters: {
          name: 'vuetifyWidgets.dr-data-widget.parameters',
          type: 'string'
        }
      }
    },
    Parameters: {
      type: 'object'
    }
  }
}

export default {
  schema,
  component: drDataWidget,
  propEditors: [
    {
      name: 'dr-data-widget-prop-editor'
    }
  ]
}
